module.exports = __webpack_public_path__ + "img/used-sort-rounded.c452d2e2.svg";